import { useState, useCallback, Fragment } from 'react';
import { Button, Drawer, Alert, Typography } from 'antd';
import { PoweroffOutlined, MenuOutlined } from '@ant-design/icons';
import { useMedia } from 'react-use';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import NavMenu from 'components/molecules/NavMenu';
import logo from 'assets/icons/login-cover.png';

import './index.scss';

const TopHeader = ({ logout, errors }) => {
  const [open, setOpen] = useState(false);
  const isWide = useMedia('(min-width: 1201px)');
  const { t } = useTranslation(['header', 'alert']);

  const onToggle = useCallback(() => {
    setOpen((open) => !open);
  }, []);

  return (
    <Fragment>
      <div className="site-header">
        <div className="header-brand">
          <Link to="/makers" className="site-logo-link">
            <img src={logo} alt="El Doctor" className="site-logo" />
          </Link>
          {isWide && <NavMenu mode="horizontal" overflowedIndicator={false} />}
        </div>
        <div className="custom-menu-item">
          <Button type="primary" icon={<PoweroffOutlined />} onClick={logout}>
            {t('header:logout')}
          </Button>
          {!isWide && (
            <Fragment>
              <Button type="primary" onClick={onToggle} icon={<MenuOutlined />} aria-label={t('header:menu')} />
              {/* Opens from the right: the menu is Arabic and right-aligned, so
                  it should enter from the side the reader starts on. */}
              <Drawer
                visible={open}
                placement="right"
                onClose={onToggle}
                className="nav-drawer"
                width={288}
                title={<img src={logo} alt="El Doctor" className="site-logo" />}
              >
                <NavMenu onClick={onToggle} mode="inline" className="sider-menu" />
              </Drawer>
            </Fragment>
          )}
        </div>
      </div>
      {errors && (
        <Alert
          type="error"
          message={
            <Typography.Title level={3} type="danger">
              {t(`alert:${errors}`)}
            </Typography.Title>
          }
          className="logout-alert"
        />
      )}
    </Fragment>
  );
};

TopHeader.PropType = {
  logout: PropTypes.func,
};

export default TopHeader;
